import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import CheckCircle from "../../images/check-circle.svg";
import RemoveCircle from "../../images/remove-circle.svg";
import { ProductFeatureValue } from "./FeatureCell";
export const FeatureCellMobile = t0 => {
  const $ = _c(7);
  const {
    value
  } = t0;
  if (value.displayType === "text") {
    let t1;
    if ($[0] !== value.text) {
      t1 = <div className="p-2 w-full max-w-[131px]">{value.text}</div>;
      $[0] = value.text;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== value.iconType) {
    t1 = value.iconType === "checkmark" ? <Image src={CheckCircle} alt="Feature included" /> : <Image src={RemoveCircle} alt="Feature not included" />;
    $[2] = value.iconType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const icon = t1;
  const t2 = `w-full max-w-[131px] flex justify-center icon-${value.iconType}`;
  let t3;
  if ($[4] !== icon || $[5] !== t2) {
    t3 = <div className={t2}>{icon}</div>;
    $[4] = icon;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};